// Running is the normal state: a green dot. Anything else gets a word too.
const STATUS: Record<string, { dot: string; label: string | null }> = {
  running: { dot: "bg-emerald-500", label: null },
  stopped: { dot: "bg-stone-400", label: "Paused" },
  creating: {
    dot: "bg-amber-500 animate-pulse motion-reduce:animate-none",
    label: "Setting up",
  },
  restarting: {
    dot: "bg-amber-500 animate-pulse motion-reduce:animate-none",
    label: "Restarting",
  },
  error: { dot: "bg-red-500", label: "Failed" },
};

export function booStatus(deploymentStatus: string): { dot: string; label: string | null } {
  return STATUS[deploymentStatus] ?? STATUS.stopped;
}
